const convertMinimumRounding = (value: number, minimumValue: number, afterDecimal = 0, isRounding = true) => {
  const multiplier = Math.pow(10, afterDecimal);
  const enforcedValue = value < minimumValue ? minimumValue : value;
  return Number((isRounding ? Math.round(enforcedValue * multiplier) : enforcedValue * multiplier / multiplier).toFixed(afterDecimal));
};
export default convertMinimumRounding;